export const AuthFlow = {
  REGISTER: "auth/register",
  LOGIN: "auth/login",
  FORGET_PASSWORD: "auth/password/forgot",
  RESET_PASSWORD: "auth/password/reset",
  CONFIRM_TOKEN: "auth/password",
};

export const UserFlow = {
  USER: "user/profile",
  USER_ADMIN: "admin/manage-users",
  USER_RESELLER: "reseller/manage-users",
  RESELLER: "admin/reseller",
};

// Cic config
export const CicConfig = {
  SECTION: "sections",
  API: "cic/config",
  CATEGORIES: "cic/categories",
  PRODUCTS_CIC: "cic/products",
};

// Products

export const ProductFlow = {
  PRODUCTS: "products/",
  PRODUCTS_BY_SECTION: "/sections/product",
  PRODUCTS_SECTION: "sections",
  PRODUCTS_ATTRIBUTE: "winedata/attributes",
};

// Category flow
export const CategoryFlow = {
  CATEGORIES: "categories/",
  SUB_CATEGORIES: "subcategories/",
  SECTION_CATEGORIES: "sections",
};

export const WineDataSet = {
  WINE_DATA: "admin/winedata",
  WINE_DATA_GET: "winedata",
  WINE_DATA_UNAPPROVED: "admin/winedata/requests",
  WINE_DATA_APPROVED: "admin/winedata/requests/approve",
  WINE_DATA_SEARCH: "winedata/search",
};

export const Beverages = {
  SCHEMA: "admin/beverages/schema",
  BEVERAGES: "admin/beverages",
  AI_DRAFT: "admin/beverages/ai-draft",
};

export const Notification = {
  ADMIN_NOTIFICATION_EVENTS: "events/",
  ADMIN_NOTIFICATION_READ: "winedata/notification/read",
  ADMIN_NOTIFICATIONS_List: "winedata/notifications",
  SETTING_CREDENTIALS: "admin/notification/credentials",
};
